import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Box, Typography } from '@mui/material';

const COLORS = ['#667eea', '#ffa726', '#29b6f6', '#66bb6a', '#d32f2f'];

const StatusPieChart = ({ data }) => {
  console.log('Status Chart Data:', data);
  
  // Handle empty data
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100%',
          flexDirection: 'column'
        }}
      >
        <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
          No status data available
        </Typography>
        <Typography variant="body2" sx={{ color: '#999' }}>
          Data count: {data ? data.length : 0}
        </Typography>
      </Box>
    );
  }
  
  return (
    <Box sx={{ width: '600px', height: '100%', margin: '0 auto' }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="status"
            cx="50%"
            cy="50%"
            innerRadius={60}
            outerRadius={120}
            paddingAngle={5}
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(1)}%`}
          >
            {data.map((entry, idx) => (
              <Cell key={`cell-${idx}`} fill={COLORS[idx % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip formatter={(value) => [value, 'Count']} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default StatusPieChart;